function handleMenu() {
	var menu = document.getElementById('js-mobile-menu');
	var menuTrigger = document.getElementById('js-menu-trigger');
	var header = document.querySelector('header');
	var body = document.body;

	function positionMenu() {
		var headerBottom = header.getBoundingClientRect().bottom;
		menu.style.top = headerBottom + 'px';
		menu.style.height = (window.innerHeight - headerBottom) + 'px';
	}

	menuTrigger.addEventListener('click', function (e) {
		e.preventDefault();
		if (!menu.classList.contains('is-open')) positionMenu();
		menu.classList.toggle('is-open');
		menuTrigger.classList.toggle('is-open');
		body.classList.toggle('overflow-hidden');
	});

	window.addEventListener('resize', function () {
		if (menu.classList.contains('is-open')) positionMenu();
	});
}

handleMenu();

function handleMobileDropdown() {
	const childMenus = document.querySelectorAll('.menu__item--has-children');

	childMenus.forEach(function (el) {
		const childMenuTrigger = el.querySelector('.child-menu__trigger');
		const childMenu = el.querySelector('.child-menu');

		childMenuTrigger.addEventListener('click', function () {
			childMenu.classList.toggle('is-open');
		});
	});
}

handleMobileDropdown();
